import { Box, Button, Card, Flex } from '@chakra-ui/react'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import { createContext, useEffect, useState } from 'react'

import { ContractsExportForm } from '@/containers/export/ContractsExportForm'
import { ContractsPropertySearch } from '@/containers/search/ContractsPropertySearch'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { ContractsList } from '../../containers/contracts/ContractsList'
import { DashboardHeader } from '../../containers/dashboard/DashboardHeader'
import { PageToolbar } from '../../containers/PageToolbar'
import { SearchButton } from '../../containers/search/SearchButton'
import { WithAuth } from '../../hoc/WithAuth'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { PageWrapper } from '../../layouts/components/PageWrapper'

export const contractsPropertyContext = createContext<
  IPaginationContext<InsuranceParamsPagedQuery>
>({} as IPaginationContext<InsuranceParamsPagedQuery>)

const ContractsPropertyPageComponent = () => {
  const [isSearchOpen, setSearchOpen] = useState(false)
  const [isExportOpen, setExportOpen] = useState(false)

  const [filter, setFilter, searchParams] =
    useSearchParamsStatePersistance<InsuranceParamsPagedQuery>(
      {
        listType: 2,
        pageIndex: 1,
        pageSize: 10,
      },
      ['listType'],
    )

  const { data, mutateAsync: getAllAsync, isLoading: isLoading } = useGetAll()
  const items = data?.data

  useEffect(() => {
    if (filter.pageSize)
      // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter])

  return (
    <PageWrapper
      header={<DashboardHeader title="Smlouvy" />}
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 4, display: 'grid' } }}
    >
      <PageToolbar
        rightElements={
          <Flex sx={{ gap: 4 }}>
            <Button onClick={() => setExportOpen(!isExportOpen)}>
              {isExportOpen ? 'Skrýt export' : 'Export'}
            </Button>
            <SearchButton isOpen={isSearchOpen} toggleOpen={() => setSearchOpen(!isSearchOpen)} />
          </Flex>
        }
      />

      <contractsPropertyContext.Provider
        value={{
          loading: isLoading,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 10,
          filter: filter,
          setCurrentPage: (p: number) => setFilter({ ...filter, pageIndex: p }),
          setPageSize: (s: number) => setFilter({ ...filter, pageSize: s }),
          updateFilter: setFilter,
          reload: () => { },
        }}
      >
        {isSearchOpen && <ContractsPropertySearch />}
        {isExportOpen && <ContractsExportForm />}

        <Card>
          <Box
            sx={{
              display: 'grid',
              gap: 8,
              placeItems: 'start',
              justifyItems: 'stretch',
            }}
          >
            <ContractsList contracts={items?.items ?? []} withPaginator />
          </Box>
        </Card>
      </contractsPropertyContext.Provider>
    </PageWrapper>
  )
}

export const ContractsPropertyPage = WithAuth(ContractsPropertyPageComponent)
